import './LogoMarquee.css';

/**
 * LogoMarquee
 * An infinite horizontal strip that scrolls by itself and pauses when the
 * cursor rests on it. The list is duplicated so the loop has no visible
 * seam. Names here are placeholders - swap for real partner logos.
 */
const DEFAULT_PARTNERS = [
  'Meridian Labs',
  'Northbeam',
  'Aurora Chain',
  'Fintary',
  'Latch Protocol',
  'Vellum Trust',
  'Quiet Ledger',
  'Kestrel Capital',
];

export default function LogoMarquee({ items = DEFAULT_PARTNERS }) {
  const track = [...items, ...items];

  return (
    <div className="marquee">
      <div className="marquee__track">
        {track.map((name, i) => (
          <div className="marquee__chip" key={`${name}-${i}`}>
            {name}
          </div>
        ))}
      </div>
    </div>
  );
}
